import { Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import ROUTES from 'utils/constants/routes.json';
import { Tile } from 'components/tile';
import { COLORS, STYLES } from 'utils/constants/styles';
import patientPortal from '../assets/img/portal-pacjenta.png';
import resultPortal from '../assets/img/portal-wyniku.png';
import copyOfMedicalClerking from '../assets/img/odpis-dokumentacji.png';

const Container = styled.div`
    width: 95%;
    max-width: 1500px;
    margin: 0 auto;
    padding-bottom: 50px;
    box-sizing: border-box;

    h1 {
        color: #595959;
        font-size: 20px;
        text-align: center;
        margin-bottom: 25px;

        @media (min-width: 499px) {
            font-size: 30px;
        }

        @media (min-width: 1199px) {
            margin-bottom: 50px;
        }
    }

    .logo {
        display: block;
        margin: 0 auto;
    }
`;

const StyledRow = styled(Row)`
    width: 100%;
    justify-content: space-between;
`;

const H1 = styled.h1`
    color: ${props => props.theme.text.black} !important;
    font-size: 25px !important;
`;

const Wrapper = styled.div`
    background: ${props => props.theme.background.white || COLORS.WHITE};
    box-sizing: border-box;
    padding-top: ${STYLES.CONTENT_PADDING_TOP};
`;

const LandingPage: React.FC<{}> = () => {
    const history = useHistory();
    const { t } = useTranslation('landingPage');
    return (
        <Wrapper className="container">
            <Container>
                <Row justify="center" style={{ width: '100%' }}>
                    <Col span={24}>
                        <H1>{t('where')}</H1>
                    </Col>
                </Row>
                <StyledRow gutter={[0, 32]}>
                    <Tile
                        imageSrc={resultPortal}
                        header={t('result_portal')}
                        description={t('result_portal_body')}
                        onClick={() => history.push(ROUTES.login_result)}
                    />
                    <Tile
                        imageSrc={patientPortal}
                        header={t('patient_portal')}
                        description={t('patient_portal_body')}
                        onClick={() => history.push(ROUTES.login_portal)}
                    />
                    <Tile
                        imageSrc={copyOfMedicalClerking}
                        header={t('copy_of_medical_clerking')}
                        description={t('copy_of_medical_clerking_body')}
                        onClick={() => history.push(ROUTES.copy_of_medical_clerking)}
                    />
                </StyledRow>
            </Container>
        </Wrapper>
    );
};

export default LandingPage;
